const NotificationManagement = {
  /**
   * Endpoint for send notification.
   * @memberof NotificationManagement
   * @type {object}
   * @property {string} url - The URL for send notification.
   * @property {string} method - The HTTP method for send notification (POST).
   */

  sendNotification: {
    url: "/user-notification",
    method: "POST",
  },
};

// Export the Notification Management object for use in other modules
export default NotificationManagement;
